<template>
  <div></div>
</template>

<script>
  import {Howl} from 'howler';
  import applicationEventHub from "../../../events/applicationEventHub";
  export default {
    name: "FrameworkSoundPlayer",
    data(){
      return {
        sound : null,
        canPlay:false,
        sprites: {
          "achievement1": [
            0,
            6000
          ],
          "achievement2": [
            7000,
            4993.809523809525
          ],
          "achievement3": [
            13000,
            6500
          ],
          "achievement4": [
            21000,
            3302.2902494331065
          ],
          "achievement5": [
            26000,
            6443.537414965987
          ],
          "applause": [
            34000,
            11051.247165532877
          ],
          "recording_could_not_start": [
            47000,
            925.3287981859444
          ],
          "recording_countdown": [
            49000,
            255.9863945578229
          ],
          "recording_finally_stopped": [
            51000,
            925.3287981859444
          ],
          "recording_get_ready": [
            53000,
            1500
          ],
          "recording_started": [
            56000,
            232.19954648526198
          ],
          "recording_stopped_error": [
            58000,
            201.42857142857196
          ],
          "recording_time_almost_reached": [
            60000,
            116.09977324263099
          ],
          "recording_time_reached": [
            62000,
            551.3378684807221
          ],
          "success1": [
            64000,
            4000
          ],
          "success2": [
            69000,
            1363.900226757366
          ],
          "success3": [
            72000,
            1363.900226757366
          ]
        }
      }
    },
    created(){
      this.init();
      this.hook();
    },
    computed:{
      volume(){
        return 0.8*(this.$store.state.media.volume/100);
      }
    },
    watch:{
      volume(){
        if(this.canPlay){
          this.sound.volume(this.volume);
        }
      }
    },
    methods:{
       hook(){
          applicationEventHub.$on('sound',this.playSound);
       },
       playSound(code){
         if(!this.canPlay) return;

        if(code.includes('_applause')){
            code=code.replace('_applause','');
           this.sound.play(code);
           setTimeout(()=>{
             const appl=this.sound.play('applause');
             this.sound.fade(1, 0, 8000, appl);
           },1000);
         }else{
           this.sound.play(code);
         }
       },
       init(){
         this.sound=new Howl({
           src: [
             "/sounds/framework_sounds.ogg",
             "/sounds/framework_sounds.mp3"
           ],
           sprite: this.sprites,
           volume:this.volume
         });

         this.sound.once('load',()=>{
           this.canPlay=true;
         });
       }
    }
  }
</script>

<style scoped>

</style>